export function trackTiktokEvent(eventName) {
  const ttclid = new URLSearchParams(window.location.search).get('ttclid') || undefined

  fetch('/.netlify/functions/tiktok-event', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      event_name: eventName,
      event_source_url: window.location.href,
      ...(ttclid && { ttclid }),
    }),
  }).catch(() => {})
}
